import React, { useEffect, useState } from "react";
import { ArrowDownToLine, ArrowUpToLine } from "lucide-react";

const EDGE_THRESHOLD = 160;

export default function ScrollControls() {
  const [position, setPosition] = useState({ atTop: true, atBottom: false });

  useEffect(() => {
    const updatePosition = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const viewportBottom = scrollTop + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      setPosition({
        atTop: scrollTop <= EDGE_THRESHOLD,
        atBottom: viewportBottom >= pageHeight - EDGE_THRESHOLD,
      });
    };

    updatePosition();
    window.addEventListener("scroll", updatePosition, { passive: true });
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  const buttonClass =
    "group relative flex h-11 w-11 items-center justify-center rounded-full border border-white/70 bg-[var(--color-bg-dark)] text-white shadow-lg transition hover:bg-[var(--color-primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-primary-light)]";

  return (
    <nav
      aria-label="Cuộn nhanh trang"
      className="fixed bottom-[5.25rem] right-3 z-40 flex flex-col gap-2 md:bottom-6 md:left-6 md:right-auto"
    >
      {!position.atTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          title="Lên đầu trang"
          aria-label="Lên đầu trang"
          className={buttonClass}
        >
          <ArrowUpToLine className="h-5 w-5" />
          <span className="pointer-events-none absolute left-12 hidden whitespace-nowrap rounded-md bg-[var(--color-bg-dark)] px-3 py-1 text-xs font-medium text-white opacity-0 shadow-md transition group-hover:opacity-100 md:block">
            Lên đầu trang
          </span>
        </button>
      )}

      {!position.atBottom && (
        <button
          type="button"
          onClick={() =>
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: "smooth",
            })
          }
          title="Xuống cuối trang"
          aria-label="Xuống cuối trang"
          className={buttonClass}
        >
          <ArrowDownToLine className="h-5 w-5" />
          <span className="pointer-events-none absolute left-12 hidden whitespace-nowrap rounded-md bg-[var(--color-bg-dark)] px-3 py-1 text-xs font-medium text-white opacity-0 shadow-md transition group-hover:opacity-100 md:block">
            Xuống cuối trang
          </span>
        </button>
      )}
    </nav>
  );
}
